import {
    Box,
    Text,
    Image,
    Button,
    VStack,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputLeftElement,
    Textarea,useToast
  } from "@chakra-ui/react";
  import { MdOutlineEmail } from "react-icons/md";
  import { BsPerson } from "react-icons/bs";
  import { IoMdContacts } from "react-icons/io";
 
  import emailjs from "@emailjs/browser"
  import {useState} from "react";
  
  export default function Form() {
  
    const intEmail = {
      from_name: "",
      to_name: "Prince Singh",
      email_id: "",
      message: "",
    };
    const [form, setForm] = useState(intEmail);
    const toast = useToast();
    const [isLoading, setLoding] = useState(false);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setForm({ ...form, [name]: value });
    };
    
    const  handleClick = () => {
     
  
  
      emailjs.send("service_7wvbfaf", "template_h4f5ike", form , "CdIDWr37TLjHUnb41")
        .then(
          (result) =>(setForm(intEmail),
        toast({
          title: "Email Send Successfully",
          status: "success",
          duration: 9000,
          isClosable: true,
        }),
        setLoding(false)
      ),
      (error) => (
        toast({
          title: "Sorry Something Went Wrong",
          status: "error",
          duration: 9000,
          isClosable: true,
        }),
        setLoding(false)
      )
    );
      }
    return (
  
      <Box align="center"   id="Contact">
        <Text
          fontFamily="Serif"
          fontWeight="400"
          fontSize={["3xl", "4xl", "5xl"]}
          p="40px 0px"
          display="flex"
          alignItems="center"
          gap={["10px", "10px", "10px"]}
          justifyContent="center"
         
        >
          Contact Me <IoMdContacts />
        </Text>
        {/* <Image
                width="200px"
                height="100px"
                borderRadius={10}
                src={logo}
                align="center"
                
                alt="shikha.com"
              /> */}
        <Box   _hover={{
            border:"none",
            textDecoration: "none" ,
            transitionDuration: "1000ms",
            transform:"scale(1.1)",
            cursor:"pointer",
          
          }} p={4} align="center">
          <Box bg="black" w={["100%" ,"100%","50%","50%"]} borderRadius="lg">
            <Box m={8} p={5} color="white">
              <VStack spacing={5} >
              
                <FormControl id="name">
                  <FormLabel>Your Name</FormLabel>
                  <InputGroup borderColor="#E0E1E7">
                    <InputLeftElement
                      pointerEvents="none"
                      children={<BsPerson color="gray.800" />}
                    />
                    <Input type="email" size="md"  name="from_name"
              value={form.from_name}
              onChange={handleChange} />
                  </InputGroup>
                </FormControl>
                <FormControl id="name">
                  <FormLabel>Mail</FormLabel>
                  <InputGroup borderColor="#E0E1E7">
                    <InputLeftElement
                      pointerEvents="none"
                      children={<MdOutlineEmail color="gray.800" />}
                    />
                    <Input type="text" size="md"   name="email_id"
              value={form.email_id}
              onChange={handleChange}/>
                  </InputGroup>
                </FormControl>
                <FormControl id="name">
                  <FormLabel>Message</FormLabel>
                  <Textarea 
                  name="message"
              value={form.message}
              onChange={handleChange}
                    borderColor="gray.300"
                    _hover={{
                      borderRadius: "gray.300",
                    }}
                    placeholder="message"
                  />
                </FormControl>
                <FormControl id="name" float="right">
                  <Button onClick={ handleClick}  type="submit" variant="solid" bg="yellow.800" color="white" isDisabled={
                form.email_id.length <= 0 ||
                form.from_name.length <= 0 ||
                form.message.length <= 0
              } isLoading={isLoading} _hover={{color :"black"}}>
                    Send Message 
                  </Button>
                </FormControl>
  
              </VStack>
            </Box>
          </Box>
        </Box>{" "}
      </Box>
    );
  }